import { createFileRoute } from '@tanstack/react-router';

import { WorkspaceUserListScreen } from '@/features/users/components/workspace/UserListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/workspace/users/')({
  beforeLoad: () => {
    requirePermission('user:read');
  },
  component: WorkspaceUserListScreen,
  staticData: { crumb: 'Users' },
});
